
export var gl: WebGL2RenderingContext;
export function setGL(_gl: WebGL2RenderingContext) {
  gl = _gl;
}



// WEBPACK FOOTER //
// ./src/globals.ts